import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useShop } from '../../../context/ShopContext';

const Wishlist = () => {
  const navigate = useNavigate();
  const { wishlist, addToCart, toggleWishlist } = useShop();

  if (wishlist.length === 0) {
    return (
      <div className="p-6 max-w-4xl w-full">
        <h2 className="text-xl font-medium mb-6">Lista e dëshirave</h2>
        <div className="border border-dashed border-gray-300 rounded-md p-8 text-center">
          <p className="text-gray-600 mb-4">Ende nuk keni shtuar produkte në listën e dëshirave.</p>
          <button
            className="bg-black text-white text-sm py-2 px-4 rounded"
            onClick={() => navigate('/products')}
          >
            Shfleto produktet
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl w-full">
      <h2 className="text-xl font-medium mb-6">Lista e dëshirave</h2>

      <div className="border border-gray-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600 uppercase text-xs border-b border-gray-200">
            <tr>
              <th className="px-4 py-3 text-left">PRODUKTET</th>
              <th className="px-4 py-3 text-left">MASA</th>
              <th className="px-4 py-3 text-left">CMIMI</th>
              <th className="px-4 py-3 text-left">STATUSI</th>
              <th className="px-4 py-3 text-left">VEPRIMET</th>
            </tr>
          </thead>
          <tbody>
            {wishlist.map((item) => (
              <tr key={item.id} className="border-b border-gray-100 last:border-b-0">
                <td className="px-4 py-3 flex items-center gap-3">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-contain rounded"
                    />
                  </div>
                  <span className="font-medium text-gray-800">{item.name}</span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {item.selectedSize || '—'}
                </td>
                <td className="px-4 py-3 font-semibold">€{item.price.toFixed(2)}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs uppercase ${item.inStock ? 'text-green-600' : 'text-red-600'}`}>
                    {item.inStock ? 'IN STOCK' : 'OUT OF STOCK'}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    <button
                      className="bg-black text-white text-xs py-2 px-3 rounded-sm uppercase"
                      onClick={() => {
                        if (item.sizes?.length && !item.selectedSize) {
                          toast.error('Ky produkt kërkon zgjedhjen e një madhësie. Ju ridrejtojmë te faqja e produktit.');
                          const targetId = encodeURIComponent(item.productCode || item.id);
                          navigate(`/products/${targetId}`, { state: { product: item } });
                          return;
                        }
                        addToCart(item);
                        if (item.selectedSize) {
                          toast.success(`Produkti (${item.selectedSize}) u shtua në shportë.`);
                        } else {
                          toast.success('Produkti u shtua në shportë.');
                        }
                      }}
                    >
                      Shto në shportë
                    </button>
                    <button
                      className="p-2 text-gray-500 hover:text-red-600"
                      aria-label="Hiq produktin nga lista e dëshirave"
                      onClick={() => toggleWishlist(item)}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
                        <path d="M15 9L9 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15 15L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Wishlist;